import { QueryClientProvider } from '@tanstack/react-query'
import { ReduxBundlerProvider, useConnect } from 'redux-bundler-hook'

import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { HelmetProvider } from 'react-helmet-async'

import App from './App'
import { queryClient } from './IO/Api'
import createLogger from './Lib/Logging'
import themes from './UI/Theme'

const _logger = createLogger('Root')

const UIWrapper = ({ AppMain, ...rest }) => {
  const { locale } = useConnect('selectLocale')
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes.DEFAULT}>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={locale}>
          <HelmetProvider>
            <AppMain {...rest} />
          </HelmetProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

const StoreWrapper = ({ store, ...rest }) => (
  <ReduxBundlerProvider store={store}>
    <QueryClientProvider client={queryClient}>
      <UIWrapper {...rest} />
    </QueryClientProvider>
  </ReduxBundlerProvider>
)

const Root = ({ AppMain = App, store, ...rest }) =>
  store ? <StoreWrapper {...rest} AppMain={AppMain} store={store} /> : <UIWrapper {...rest} AppMain={AppMain} />

export default Root
